<template>
  <div class="d-flex">
    <div>
      <v-btn
        class="mr-2 mb-1 pa-2 rounded-circle d-inline-block"
        color="primary"
        min-width="20px"
        height="20px"
        style="cursor-pointer: grab"
      />
    </div>
    <div class="full-width">
      <div class="d-flex align-center">
        <div>{{ address }} {{ time }}</div>
        <div>
          <v-icon class="mx-4" color="green" @click="onAddStudent">mdi-account-plus</v-icon>

          <v-icon :disabled="!isRemoveStudentEnabled" color="red" @click="onRemoveStudent">mdi-account-minus</v-icon>
          <v-icon @click="onUpdateBusStop" class="mx-4" color="blue">mdi-pencil</v-icon>
          <v-icon @click="onDeleteBusStop" color="red">mdi-delete</v-icon>
        </div>
      </div>
      <div class="mt-2 ml-8">
        <BusScheduleItemStudentRow
          v-for="student in item.students"
          :key="student.id"
          :student="student"
          :item="item"
          @on-edit-default-absent="onEditDefaultAbsent"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash'
import BusScheduleItemStudentRow from './BusScheduleItemStudentRow.vue'
export default {
  components: {
    BusScheduleItemStudentRow,
  },
  props: {
    item: Object,
  },
  data() {
    return {
      address: '',
      time: '',
      isRemoveStudentEnabled: false,
    }
  },
  methods: {
    handleItem(item = {}) {
      this.address = item.address
      this.time = this.getScheduleTimeInOut(item)
      this.isRemoveStudentEnabled = get(item, 'students.length', 0) > 0
    },
    getScheduleTimeInOut(busStop) {
      const REGEX_MATCH_TIME_HHMM = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/
      const { timeIn, timeOut } = busStop
      const result = []
      if (timeIn && timeIn.match(REGEX_MATCH_TIME_HHMM)) result.push(timeIn)
      if (timeOut && timeOut.match(REGEX_MATCH_TIME_HHMM)) result.push(timeOut)
      if (result.length) return `(${result.join(' - ')})`
      return ''
    },
    onAddStudent() {
      this.$emit('on-add-student', this.item)
    },
    onRemoveStudent() {
      this.$emit('on-remove-student', this.item)
    },
    onUpdateBusStop() {
      this.$emit('on-update-bus-stop', this.item)
    },
    onDeleteBusStop() {
      this.$emit('on-delete-bus-stop', this.item)
    },
    onEditDefaultAbsent(student = {}) {
      this.$emit('on-edit-student-default-absent', { student, busStop: this.item })
    },
  },
  watch: {
    item: {
      handler(val) {
        this.handleItem(val)
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>
